import { useQuery } from '@tanstack/react-query';
import { lacAnalyticsService } from '../../../services/LacAnalyticsService';
import { lacQueryKeys } from '../lacQueryKeys';

type UseLacTenantDailyCostsQueryOptions = {
  tenantName: string;
  fromDay: string;
  toDay: string;
  enabled?: boolean;
};

export function useLacTenantDailyCostsQuery({
  tenantName,
  fromDay,
  toDay,
  enabled = true,
}: UseLacTenantDailyCostsQueryOptions) {
  const trimmedTenantName = tenantName.trim();

  return useQuery({
    queryKey: lacQueryKeys.tenantDailyCosts(trimmedTenantName, fromDay, toDay),
    enabled:
      enabled &&
      trimmedTenantName.length > 0 &&
      fromDay.length > 0 &&
      toDay.length > 0,
    queryFn: () =>
      lacAnalyticsService.getDailyCosts(trimmedTenantName, fromDay, toDay),
  });
}
